import { render, staticRenderFns } from "./AgentDictionary.vue?vue&type=template&id=3bc6cc81&scoped=true&"
import script from "./AgentDictionary.vue?vue&type=script&lang=js&"
export * from "./AgentDictionary.vue?vue&type=script&lang=js&"
import style0 from "./AgentDictionary.vue?vue&type=style&index=0&id=3bc6cc81&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc6cc81",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VDialog,
  VIcon,
  VTextField,
})
